import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_TRANSACTIONS_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f01ff',
  name: 'payments_transactions',
  description: 'Transaction reporting — the transaction table, disputes, suspicious activity and exports',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
